import React from 'react';

export function ProfilePhoneIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeWidth="1.5"
        d="M2 3a1 1 0 0 1 1-1h3.153c.488 0 .902.353.983.835l.727 4.33c.071.435-.153.864-.554 1.064l-1.81.77c1 2.5 3 4.5 5.5 5.5l.771-1.81c.2-.4.629-.625 1.064-.553l4.33.727c.481.08.835.495.835.983V17a1 1 0 0 1-1 1h-2C7.82 17.999 2 12.179 2 4.999z"
      />
    </svg>
  );
}
